// see http://vuejs-templates.github.io/webpack for documentation.
var path = require('path')
var request = require('superagent')

module.exports = {
  build: {
    env: require('./prod.env'),
    index: path.resolve(__dirname, '../dist/index.html'),
    assetsRoot: path.resolve(__dirname, '../dist'),
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    productionSourceMap: true,
    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ['js', 'css'],
    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: process.env.npm_config_report,
    proxyTable: {
      '/api': {
        target: 'http://20.116.20.185/',
        changeOrigin: true
      },
      '/Documents': {
        target: 'http://20.116.20.185/',
        changeOrigin: true
      },
      '/Account': {
        target: 'http://20.116.20.185/',
        changeOrigin: true
      },
      '/Visualize': {
        target: 'http://20.116.20.185/',
        changeOrigin: true
      },
      '/WaterQualityReport': {
        target: 'http://20.116.20.185/',
        changeOrigin: true
      },
      '/LabDataExport': {
        target: 'http://20.116.20.185/',
        changeOrigin: true
      },
      '/upload': {
        target: 'http://localhost:3000',
        changeOrigin: true
      },
      '/uploads': {
        target: 'http://localhost:3000',
        changeOrigin: true
      },
      '/jsnlog.logger': {
        target: 'http://20.116.20.185/',
        changeOrigin: true
      },
      '/token': {
        target: 'http://20.116.20.185/',
        changeOrigin: true
      },
      '/arcGisToken': {
        target: 'https://www.arcgis.com/sharing/rest/oauth2/token',
        changeOrigin: true
      },
      '/Report': {
        target: 'http://20.116.20.185/',
        changeOrigin: true
      },
    },
  },
  localdev: {
    env: require('./dev.env'),
    port: 8989,
    autoOpenBrowser: false,
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    proxyTable: {
      '/api': {
        target: 'http://localhost:53792',
        changeOrigin: true
      },
      '/Documents': {
        target: 'http://localhost:53792',
        changeOrigin: true
      },
      '/Account': {
        target: 'http://localhost:53792',
        changeOrigin: true
      },
      '/Visualize': {
        target: 'http://localhost:53792',
        changeOrigin: true
      },
      '/WaterQualityReport': {
        target: 'http://localhost:53792',
        changeOrigin: true
      },
      '/LabDataExport': {
        target: 'http://localhost:53792',
        changeOrigin: true
      },
      '/upload': {
        target: 'http://localhost:3000',
        changeOrigin: true
      },
      '/uploads': {
        target: 'http://localhost:3000',
        changeOrigin: true
      },
      '/jsnlog.logger': {
        target: 'http://localhost:53792',
        changeOrigin: true
      },
      '/token': {
        target: 'http://localhost:53792',
        changeOrigin: true
      },
      '/arcGisToken': {
        target: 'https://www.arcgis.com/sharing/rest/oauth2/token',
        changeOrigin: true
      },
      '/Report': {
        target: 'http://localhost:53792',
        changeOrigin: true
      },
      '/cdi': {
        target: 'http://localhost:5009',
        changeOrigin: true,
        pathRewrite: {
          '^/cdi': ''
        }
      }
    },

    // CSS Sourcemaps off by default because relative paths are "buggy"
    // with this option, according to the CSS-Loader README
    // (https://github.com/webpack/css-loader#sourcemaps)
    // In our experience, they generally work as expected,
    // just be aware of this issue when enabling this option.
    cssSourceMap: false
  },
  dev: {
    env: require('./dev.env'),
    port: 8989,
    autoOpenBrowser: false,
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    proxyTable: {
      '/api': {
        target: 'http://hf-raissa-old:8400',
        changeOrigin: true
      },
      '/Documents': {
        target: 'http://hf-raissa-old:8400',
        changeOrigin: true
      },
      '/Account': {
        target: 'http://hf-raissa-old:8400',
        changeOrigin: true
      },
      '/Visualize': {
        target: 'http://hf-raissa-old:8400',
        changeOrigin: true
      },
      '/WaterQualityReport': {
        target: 'http://hf-raissa-old:8400',
        changeOrigin: true
      },
      '/LabDataExport': {
        target: 'http://hf-raissa-old:8400',
        changeOrigin: true
      },
      '/upload': {
        target: 'http://hf-nv-build2:3000',
        changeOrigin: true
      },
      '/uploads': {
        target: 'http://hf-nv-build2:3000',
        changeOrigin: true
      },
      '/jsnlog.logger': {
        target: 'http://hf-raissa-old:8400',
        changeOrigin: true
      },
      '/token': {
        target: 'http://hf-raissa-old:8400',
        changeOrigin: true
      },
      '/arcGisToken': {
        target: 'https://www.arcgis.com/sharing/rest/oauth2/token',
        changeOrigin: true
      },
      '/Report': {
        target: 'http://hf-raissa-old:8400',
        changeOrigin: true
      },
    },

    // CSS Sourcemaps off by default because relative paths are "buggy"
    // with this option, according to the CSS-Loader README
    // (https://github.com/webpack/css-loader#sourcemaps)
    // In our experience, they generally work as expected,
    // just be aware of this issue when enabling this option.
    cssSourceMap: false
  },
  aztest: {
    env: require('./aztest.env'),
    index: path.resolve(__dirname, '../aztest-dist/index.html'),
    assetsRoot: path.resolve(__dirname, '../aztest-dist'),
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    productionSourceMap: true,
    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ['js', 'css'],
    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: process.env.npm_config_report,
    proxyTable: {
      '/api': {
        target: 'http://envirodataplayground.canadacentral.cloudapp.azure.com:80',
        changeOrigin: true
      },
      '/Documents': {
        target: 'http://envirodataplayground.canadacentral.cloudapp.azure.com:80',
        changeOrigin: true
      },
      '/Account': {
        target: 'http://envirodataplayground.canadacentral.cloudapp.azure.com:80',
        changeOrigin: true
      },
      '/Visualize': {
        target: 'http://envirodataplayground.canadacentral.cloudapp.azure.com:80',
        changeOrigin: true
      },
      '/WaterQualityReport': {
        target: 'http://envirodataplayground.canadacentral.cloudapp.azure.com:80',
        changeOrigin: true
      },
      '/LabDataExport': {
        target: 'http://envirodataplayground.canadacentral.cloudapp.azure.com:80',
        changeOrigin: true
      },
      '/upload': {
        target: 'http://localhost:3000',
        changeOrigin: true
      },
      '/uploads': {
        target: 'http://localhost:3000',
        changeOrigin: true
      },
      '/jsnlog.logger': {
        target: 'http://envirodataplayground.canadacentral.cloudapp.azure.com:80',
        changeOrigin: true
      },
      '/token': {
        target: 'http://envirodataplayground.canadacentral.cloudapp.azure.com:80',
        changeOrigin: true
      },
      '/arcGisToken': {
        target: 'https://www.arcgis.com/sharing/rest/oauth2/token',
        changeOrigin: true
      },
      '/Report': {
        target: 'http://envirodataplayground.canadacentral.cloudapp.azure.com:80',
        changeOrigin: true
      },
    },
  }
}
